import {
    ActionService,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {inject, Injectable} from "@angular/core";

export class AppDeviceLogoutActionData extends EntityData<AppDeviceLogoutActionData> {
    @field waiterName: string;
    @field deviceName: string;
}

/**
 * Service to record a logout from a device.
 */
@Injectable({providedIn: "root"})
export class AppDeviceLogoutService extends ActionService {

    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- AppDeviceLogoutService");

        super(http, nameSpace, "app-device-logout", configService, useAsync, actionNames);
    }
}
